import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { isCheckoutRoute } from '../helpers/checkout'
import { useCart } from './useCart'
import { useDeliveryLocation } from './useDeliveryLocation'

/** Locks the delivery area only while the checkout page is open with items in the cart. */
export function useCheckoutLocationLock() {
  const { pathname } = useLocation()
  const { lines } = useCart()
  const { lockLocation, unlockLocation } = useDeliveryLocation()
  const shouldLock = lines.length > 0 && isCheckoutRoute(pathname)

  useEffect(() => {
    if (shouldLock) lockLocation()
    else unlockLocation()
  }, [shouldLock, lockLocation, unlockLocation])
}
